var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("MonitorLayoutTemplate", {
        attrs: { table_title: _vm.table_title },
        scopedSlots: _vm._u([
          {
            key: "datetime",
            fn: function() {
              return [
                _c("QpeDatetime", {
                  attrs: {
                    props_date: _vm.date,
                    props_time: _vm.time,
                    name: _vm.default_value
                  },
                  on: {
                    "update-time": _vm.update_time,
                    "change-parent-date-time": _vm.change_parent_date_time
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "description",
            fn: function() {
              return [
                _c("SignsCalculator", { attrs: { data: _vm.sign_data } }),
                _vm._v(" "),
                _c("MapDisplaySwitch", {
                  attrs: {
                    table_id: _vm.default_value,
                    table_data: _vm.immutable_table_data
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "signs",
            fn: function() {
              return [
                _c("MonitorSigns", {
                  attrs: { data: _vm.sign_data, enable_display_tooltip: true }
                })
              ]
            },
            proxy: true
          },
          {
            key: "data_table",
            fn: function(slot_props) {
              return [
                _c("QpeDatatable", {
                  attrs: {
                    data: _vm.table_data,
                    headers: _vm.header,
                    name: _vm.default_value,
                    error_text: _vm.error_text,
                    search: slot_props.search,
                    should_draw_diagram_header: _vm.should_draw_diagram_header,
                    enable_diagram_slot: true,
                    should_display_info_header_key_value:
                      _vm.should_display_info_header_key_value,
                    generate_tooltop_display_info:
                      _vm.generate_tooltop_display_info_for_table,
                    should_show_raw_html_header:
                      _vm.should_show_raw_html_header,
                    show_download_doc_btn: true,
                    show_download_pdf_btn: _vm.show_download_pdf_btn
                  },
                  on: {
                    "update-time": _vm.update_time,
                    "change-parent-date-time": _vm.change_parent_date_time
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "table_description",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "long-explanations" }, [
                              _vm._v("\n                        說明:"),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "ol",
                                {
                                  staticClass:
                                    "long-explanations__decimal-layer"
                                },
                                [
                                  _c("li", [
                                    _vm._v("「--」 表示該欄位無資料。")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "即時資料為整點觀測，約50分鐘後可得，例如00時之觀測約於00時50分顯示。"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                浮標說明："
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "long-explanations__hide-layer"
                                      },
                                      [
                                        _c("li", [
                                          _c("mark", [
                                            _vm._v("*花蓮資料浮標：")
                                          ]),
                                          _vm._v(
                                            "花蓮七星潭海域，水深22m處經緯度：24°01'57''N，121°37'51''E\n                                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "long-explanations__indent"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        所屬單位：中央氣象署\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("mark", [
                                            _vm._v("*臺東資料浮標：")
                                          ]),
                                          _vm._v(
                                            "距臺東海堤約3km，臺東焚化爐外1km，水深30m處經緯度：24°43'24''N，121°08'37''E\n                                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "long-explanations__indent"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        所屬單位：經濟部水利署\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                台17線灣裡路段為臺南市政府代管路段，其浪襲監控仍待實際應變作業操作後，予以修正相關設定。"
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "long-explanations__hide-layer"
                                      },
                                      [
                                        _c("li", [
                                          _c("mark", [
                                            _vm._v(
                                              "*小琉球資料浮標，位置(水深)："
                                            )
                                          ]),
                                          _vm._v(
                                            "枋寮恆春沿海，小琉球海子口西南方外海約4km，該處水深約82m處。經緯度：23.3139°N，120.3514°E\n                                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "long-explanations__indent"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        所屬單位：中央氣象署\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("mark", [
                                            _vm._v(
                                              "*七美資料浮標，位置(水深)："
                                            )
                                          ]),
                                          _vm._v(
                                            "澎湖海面，澎湖縣七美鄉南方30公里,布放水深90公尺。經緯度：119.5175°E，22.9502°N\n                                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "long-explanations__indent"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        所屬單位：中央氣象署\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }